import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>
        &copy; 2018 Mark De May
      </p>
    </footer>

  )
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js